<template>
  <v-layout row justify-center>
    <v-dialog
      transition="slide-y-transition"
      v-model="cancelBookingDialog"
      max-width="570"
      persistent
      @keydown.esc="close"
    >
      <v-card class="confirm-dialog">
        <v-card-title>
          <v-layout align-center justify-center dialog-title>
            <div
              v-if="isCancelBookingLoading"
              class="progress d-flex justify-center align-center mt-4"
            >
              <v-progress-circular
                :size="50"
                color="warning"
                indeterminate
              />
            </div>
            <div
              v-if="!isCancelBookingLoading"
              class="progress d-flex justify-center align-center mt-4"
            >
              {{ cancelBookingDetails.message }}
            </div>
          </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-layout align-center justify-center class="btns-wrapper mt-4 mb-4">
            <v-btn
              type="button"
              :ripple="false"
              :disabled="isCancelBookingLoading"
              class="error mb-4 mr-4"
              depressed
              @click="close"
            >{{ $t('common.btns.back') }}</v-btn>
            <v-btn
              type="button"
              :ripple="false"
              :disabled="isCancelBookingLoading"
              class="warning mb-4"
              depressed
              @click="cancelBooking"
            >{{ $t('common.btns.cancelBooking') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'CancelBookingDialog',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      dialog: 'booking/getCancelBookingDialogState',
      cancelBookingDetails: 'booking/getCancelBookingDetails',
      cancelBookingId: 'booking/getCancelBookingId',
      isCancelBookingLoading: 'booking/getCancelBookingLoader',
    }),
    cancelBookingDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.close();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      confirmCancelBooking: 'booking/confirmCancelBooking',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      clearAlertSuccess: 'global/clearAlertSuccess',
      setAlertSuccess: 'global/setAlertSuccess',
      setCancelBookingDialogState: 'booking/setCancelBookingDialogState',
      setCancelBookingId: 'booking/setCancelBookingId',
      setCancelBookingDetails: 'booking/setCancelBookingDetails',
    }),
    async cancelBooking() {
      try {
        const message = await this.confirmCancelBooking({
          id: this.cancelBookingId,
          token: this.cancelBookingDetails.token,
        });

        this.setAlertSuccess({ message, state: true });
        this.$vuetify.goTo(0, 'easeInOutCubic');
        this.$emit('getBookingsList');

        setTimeout(() => {
          this.clearAlertSuccess();
        }, 3000);
        this.clearAlertError();
        this.close();
      } catch (error) {
        this.close();
      }
    },
    close() {
      this.setCancelBookingDialogState(false);
      this.setCancelBookingId(null);
      this.setCancelBookingDetails({});
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
    word-break: break-word;
}
.btns-wrapper {
  @media (max-width: 599px) {
      flex-direction: column;
    }
}
</style>
